import { render, staticRenderFns } from "./RetailShell.vue?vue&type=template&id=6bcd075d&scoped=true"
import script from "./RetailShell.vue?vue&type=script&lang=js"
export * from "./RetailShell.vue?vue&type=script&lang=js"
import style0 from "./RetailShell.vue?vue&type=style&index=0&id=6bcd075d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd075d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bcd075d')) {
      api.createRecord('6bcd075d', component.options)
    } else {
      api.reload('6bcd075d', component.options)
    }
    module.hot.accept("./RetailShell.vue?vue&type=template&id=6bcd075d&scoped=true", function () {
      api.rerender('6bcd075d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/cashier/RetailShell.vue"
export default component.exports